// This class applies the fading effects to FlatGrid from 'react-native-super-grid'.

import React from 'react';
import PropTypes from 'prop-types';
import {
  View,
} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'

class SuperFlatFading extends React.Component {
  viewabilityConfigCallbackPairs = [{
    viewabilityConfig: {
      itemVisiblePercentThreshold: 50,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 55,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 60,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 65,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 70,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 75,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 80,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 85,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 90,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 95,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }, {
    viewabilityConfig: {
      itemVisiblePercentThreshold: 100,
    },
    onViewableItemsChanged: this.onViewableItemsChanged.bind(this),
  }];

  constructor(props, context) {
    super(props, context);

    this.onViewableItemsChanged = this.onViewableItemsChanged.bind(this);

    this.elementTopVisibility = 100; // visibility of the first element (50 means 50% or less)
    this.elementBottomVisibility = 50; // visibility of the last element (50 means 50% or less)
  }

  onViewableItemsChanged(info) {
    const { items } = this.props;
    const count = items.length;

    info.changed.forEach((changed) => {
      const { index, isViewable } = changed;

      if (index === 0 && this.gradientTop) {
        const visibilityClaim = info.viewabilityConfig.itemVisiblePercentThreshold;
        if ((isViewable && visibilityClaim > this.elementTopVisibility)
          || (!isViewable && visibilityClaim < this.elementTopVisibility)) {
          this.elementTopVisibility = visibilityClaim;
          const opacity = (200 - visibilityClaim * 2) / 100.0;
          this.gradientTop.props.style[1].opacity = opacity;
          this.gradientTop.forceUpdate();
          // this.gradientTop.setNativeProps({
          //   style: { opacity },
          // });
        }
      }

      if (index === count - 1 && this.gradientBottom) {
        const visibilityClaim = info.viewabilityConfig.itemVisiblePercentThreshold;
        if ((isViewable && visibilityClaim > this.elementTopVisibility)
          || (!isViewable && visibilityClaim < this.elementTopVisibility)) {
          this.elementTopVisibility = visibilityClaim;
          const opacity = (200 - visibilityClaim * 2) / 100.0;
          this.gradientBottom.props.style[0].opacity = opacity;
          this.gradientBottom.forceUpdate();
          // this.gradientBottom.setNativeProps({
          //   style: { opacity },
          // });
        }
      }
    });
  }

  render() {
    const {
      Component, style, children, ...otherProps
    } = this.props;
    return (
      <View
        style={[style, {
          backgroundColor: 'white',
          flex: 1,
        }]}
      >
        <Component
          {...otherProps} // eslint-disable-line react/jsx-props-no-spreading
          viewabilityConfigCallbackPairs={this.viewabilityConfigCallbackPairs}
        >
          {children}
        </Component>

        <LinearGradient
          style={{
            position: 'absolute',
            top: 0,
            width: '100%',
            height: '20%',
            opacity: 0,
          }}
          colors={['#ffff', '#fff0']}
          pointerEvents="none"
          ref={(gradientTop) => { this.gradientTop = gradientTop; }}
        />
        <LinearGradient
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: '20%',
            opacity: 1,
          }}
          colors={['#fff0', '#ffff']}
          pointerEvents="none"
          ref={(gradientBottom) => { this.gradientBottom = gradientBottom; }}
        />
      </View>
    );
  }
}

SuperFlatFading.defaultProps = {
  style: {},
  items: [],
  children: undefined,
};

SuperFlatFading.propTypes = {
  Component: PropTypes.func.isRequired,
  style: ViewPropTypes.style,
  items: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default SuperFlatFading;
